import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

class PortfolioAPI {
  
  // Get portfolio data
  static async getPortfolio() {
    try {
      const response = await axios.get(`${API}/portfolio`);
      return response.data;
    } catch (error) {
      console.error('Error fetching portfolio:', error);
      throw error;
    }
  }

  // Upload profile image
  static async uploadProfileImage(file) {
    try {
      const formData = new FormData();
      formData.append('image', file);
      
      const response = await axios.post(`${API}/profile/image`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
      return response.data;
    } catch (error) {
      console.error('Error uploading image:', error);
      throw error;
    }
  }

  // Send contact message
  static async sendContactMessage(messageData) {
    try {
      const response = await axios.post(`${API}/contact`, messageData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      return response.data;
    } catch (error) {
      console.error('Error sending contact message:', error);
      throw error;
    }
  }

  // Update social links
  static async updateSocialLinks(linksData) {
    try {
      const response = await axios.put(`${API}/social-links`, linksData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      return response.data;
    } catch (error) {
      console.error('Error updating social links:', error);
      throw error;
    }
  }

  // Get contact messages (admin)
  static async getContactMessages() {
    try {
      const response = await axios.get(`${API}/contact`);
      return response.data;
    } catch (error) {
      console.error('Error fetching contact messages:', error);
      throw error;
    }
  }

  // Health check
  static async healthCheck() {
    try {
      const response = await axios.get(`${API}/health`);
      return response.data;
    } catch (error) {
      console.error('Error checking API health:', error);
      throw error;
    }
  }
}

export default PortfolioAPI;